module.exports = __webpack_public_path__ + "img/jt_icon.d1f59e7f.png";